import * as React from "react";
import {
  Button,
  Menu,
  MenuItem,
  MenuList,
  MenuItemLink,
  MenuPopover,
  MenuTrigger,
  mergeClasses,
  useRestoreFocusTarget,
} from "@fluentui/react-components";
import {
  bundleIcon,
  ClipboardErrorFilled,
  ClipboardErrorRegular,
  Settings24Filled,
  Settings24Regular,
} from "@fluentui/react-icons";

import { ErrorContext } from "../store/error-context-api";
import { ThemeContext } from "../store/theme-context-api";
import { useIconButtonStyles } from "../styles/styles";
import { EXTERNAL_LINKS } from "../../helpers/external-links";
import { PrivacyIcon, TermsIcon } from "./common-icons";

const ErrorIcon = bundleIcon(ClipboardErrorFilled, ClipboardErrorRegular);
const SettingsIcon = bundleIcon(Settings24Filled, Settings24Regular);

export default function Settings() {
  const { isDarkTheme } = React.useContext(ThemeContext);
  const { setOpenErrorDialog } = React.useContext(ErrorContext);
  const iconStyles = useIconButtonStyles();
  const restoreFocusTargetAttribute = useRestoreFocusTarget();

  return (
    <Menu>
      <MenuTrigger disableButtonEnhancement>
        <Button
          className={mergeClasses(isDarkTheme ? iconStyles.dark : iconStyles.light)}
          icon={<SettingsIcon />}
          shape="circular"
          appearance="transparent"
        />
      </MenuTrigger>

      <MenuPopover>
        <MenuList>
          <MenuItem
            onClick={() => setOpenErrorDialog(true)}
            className={iconStyles.dark}
            {...restoreFocusTargetAttribute}
            icon={<ErrorIcon />}
          >
            Show Errors
          </MenuItem>
          <MenuItemLink className={iconStyles.dark} icon={<PrivacyIcon />} href={EXTERNAL_LINKS.PRIVACY_POLICY}>
            Privacy Policy
          </MenuItemLink>
          <MenuItemLink className={iconStyles.dark} icon={<TermsIcon />} href={EXTERNAL_LINKS.TERMS_OF_USE}>
            Terms of use
          </MenuItemLink>
        </MenuList>
      </MenuPopover>
    </Menu>
  );
}
